import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/OrderStatusCard/order-status.ts
var DELIVERY_STEPS = ["confirmed", "shipped", "outForDelivery", "delivered"];
var PICKUP_STEPS = ["confirmed", "readyForPickup", "pickedUp"];
var PROGRESS = {
  confirmed: { track: "delivery", steps: DELIVERY_STEPS, reached: 0 },
  label_created: { track: "delivery", steps: DELIVERY_STEPS, reached: 0 },
  fulfilled: { track: "delivery", steps: DELIVERY_STEPS, reached: 1 },
  in_transit: { track: "delivery", steps: DELIVERY_STEPS, reached: 1 },
  delayed: { track: "delivery", steps: DELIVERY_STEPS, reached: 1 },
  failed: { track: "delivery", steps: DELIVERY_STEPS, reached: 1 },
  out_for_delivery: { track: "delivery", steps: DELIVERY_STEPS, reached: 2 },
  attempted_delivery: { track: "delivery", steps: DELIVERY_STEPS, reached: 2 },
  not_delivered: { track: "delivery", steps: DELIVERY_STEPS, reached: 2 },
  delivered: { track: "delivery", steps: DELIVERY_STEPS, reached: 3 },
  ready_for_pickup: { track: "pickup", steps: PICKUP_STEPS, reached: 1 },
  picked_up: { track: "pickup", steps: PICKUP_STEPS, reached: 2 },
  cancelled: null,
  unknown: null
};
function shipmentProgress(status) {
  return PROGRESS[status] ?? null;
}
function shipmentDate(shipment) {
  if (shipment.deliveredAt) return { kind: "delivered", at: shipment.deliveredAt };
  if (shipment.status === "cancelled" || shipment.status === "delivered" || shipment.status === "picked_up") return null;
  if (shipment.estimatedDeliveryAt) return { kind: "expected", at: shipment.estimatedDeliveryAt };
  return null;
}
var SHIPMENT_STATUS_KEY = {
  confirmed: "confirmed",
  label_created: "labelCreated",
  in_transit: "inTransit",
  out_for_delivery: "outForDelivery",
  attempted_delivery: "attemptedDelivery",
  delayed: "delayed",
  delivered: "delivered",
  ready_for_pickup: "readyForPickup",
  picked_up: "pickedUp",
  not_delivered: "notDelivered",
  failed: "failed",
  fulfilled: "fulfilled",
  cancelled: "cancelled",
  unknown: "unknown"
};
function shipmentStatusKey(status) {
  return `orderStatus.shipment.${SHIPMENT_STATUS_KEY[status] ?? "unknown"}`;
}
var ORDER_STATUS_KEY = {
  processing: "processing",
  on_hold: "onHold",
  partially_shipped: "partiallyShipped",
  shipped: "shipped",
  cancelled: "cancelled",
  restocked: "restocked",
  no_shipping_needed: "noShippingNeeded",
  unknown: "unknown"
};
function orderStatusKey(status) {
  return `orderStatus.status.${ORDER_STATUS_KEY[status] ?? "unknown"}`;
}
export {
  orderStatusKey,
  shipmentDate,
  shipmentProgress,
  shipmentStatusKey
};
//# sourceMappingURL=order-status.mjs.map